import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';
import { func, object } from 'prop-types';
import { startSetNotify, startEditNotify, startSetBotsInfo } from '../../actions/webmaster';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import GmailSpamAlert from '../../components/Notifications/GmailSpamAlert';
import EditNotificationsForm from '../../components/Notifications/EditNotificationsForm';
import { FMessage } from '../../hoc/IntlComponents';

class NotificationsPage extends Component {
  static propTypes = {
    startSetNotify: func.isRequired,
    startEditNotify: func.isRequired,
    startSetBotsInfo: func,
    bots: object,
  };

  static defaultProps = {
    bots: { 0: {} },
  };

  state = {
    loading: true,
    notifications: [],
    errors: {},
    message: '',
  };

  alertOnDismiss = () => {
    this.setState(() => ({ message: '' }));
  };

  openAlert = (message) => {
    this.setState(() => ({ message }));
  };

  onChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState((prevState) => {
      const _arr = target.name.split('_');
      const [index, type, field] = _arr;
      if (type === 'params') {
        prevState.notifications[index].params[field].value = value;
      } else {
        prevState.notifications[index].transport[type].checked = value;
      }

      return {
        notifications: [...prevState.notifications],
      };
    });
  };

  onSubmit = (e, verification_code) => {
    e.preventDefault();

    this.setState(() => ({ loading: true }));

    const { notifications } = this.state;
    const { intl } = this.props;

    let dataString = '';

    notifications.forEach((elem, index) => {
      let dataField = '';

      Object.keys(elem.transport).forEach((field) => {
        if (elem.transport[field].checked === true) {
          dataField += `settings[${index}][transport][]=${field}&`;
        }
      });

      Object.keys(elem.params).forEach((field) => {
        const { value } = elem.params[field];

        if (value) {
          dataField += `settings[${index}][params][${field}]=${value}&`;
        }
      });

      if (dataField) dataString += `settings[${index}][id]=${elem.id}&${dataField}`;
    });

    if (dataString.length === 0) dataString = 'settings[0][id]=1';

    this.props.startEditNotify(dataString).then(() => {
      this.setState(() => ({
        loading: false,
        message: intl.formatMessage({
          id: 'notifications.update.success',
          defaultMessage: 'Update successful',
        }),
      }));
    });

    return false;
  };

  componentDidMount() {
    this.setState(() => ({
      loading: true,
    }));

    this.props.startSetBotsInfo();
    this.props.startSetNotify().then(({ notifications }) => {
      this.setState((prevState) => ({
        ...prevState,
        loading: false,
        notifications,
      }));
    });
  }

  hasBotsInfo = () => {
    const { bots } = this.props;

    return Object.keys(bots[0]).length > 0;
  };

  render() {
    const { message, loading } = this.state;
    const { bots, profile } = this.props;
    const { name, enabled, code, link } = bots[0];

    return (
      <Layout formattedTitle="pages.notifications.title" className="notifications-page">
        <Layout.Col>
          {this.hasBotsInfo() && (
            <Card className="telegram" loading={loading}>
              <Card.Header>
                <p className="telegram-title">
                  <b>
                    <FMessage id="notifications.telegram.header" />
                    <a href={link} target="_blank">
                      <FMessage id="notifications.telegram.header.link" />
                    </a>
                  </b>
                </p>
              </Card.Header>
              {!enabled && (
                <Card.Body>
                  <p>
                    <FMessage id="notifications.telegram.text-1" />
                    <a href={link} target="_blank">
                      {name}
                    </a>
                    <FMessage id="notifications.telegram.text-2" />{' '}
                    <span className="tg-auth-code">{code}</span>
                  </p>
                </Card.Body>
              )}
            </Card>
          )}

          <GmailSpamAlert profile={profile} />

          {/* <Card loading={loading} className="card_notifications"> */}
          <Card.Header>
            <FormattedMessage id="notifications.title" defaultMessage="Notifications" />
          </Card.Header>
          {/* <Card.Body> */}
          {message && (
            <Alert color="success" toggle={this.alertOnDismiss}>
              {message}
            </Alert>
          )}
          <EditNotificationsForm
            notifications={this.state.notifications}
            submit={this.onSubmit}
            change={this.onChange}
            openAlert={this.openAlert}
            profile={profile}
          />
          {/* </Card.Body> */}
          {/* </Card> */}
        </Layout.Col>
      </Layout>
    );
  }
}

const mapStateToProps = ({ webmaster }) => ({
  bots: webmaster.bots,
  profile: webmaster.profile,
});

const mapDispatchToProps = (dispatch) => ({
  startSetNotify: (notifications) => dispatch(startSetNotify(notifications)),
  startEditNotify: (notifications) => dispatch(startEditNotify(notifications)),
  startSetBotsInfo: () => dispatch(startSetBotsInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NotificationsPage));
